import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy-page">
      <div className="container">
        <div className="content">
          <h1 className="page-title">隐私政策</h1>
          
          <p className="update-date">最后更新日期：{new Date().toLocaleDateString('zh-CN')}</p>

          <section className="section">
            <h2>引言</h2>
            <p>
              欢迎使用 数学可视化引擎（以下简称"本应用"或"我们"）。我们非常重视用户的隐私保护和个人信息安全。
              本隐私政策旨在向您说明我们如何收集、使用、存储和保护您的个人信息，以及您享有的相关权利。
            </p>
          </section>

          <section className="section">
            <h2>1. 信息收集</h2>
            <h3>1.1 我们收集的信息</h3>
            <p>
              数学可视化引擎 是一款本地化的数学计算应用。我们致力于保护您的隐私，因此：
            </p>
            <ul>
              <li>我们不会收集您的个人身份信息</li>
              <li>我们不会追踪您的位置信息</li>
              <li>您的计算历史记录仅存储在您的设备本地</li>
              <li>我们不会将您的任何数据上传到服务器</li>
            </ul>
          </section>

          <section className="section">
            <h2>2. 信息使用</h2>
            <p>
              所有计算数据和历史记录均保存在您的设备上，仅用于应用功能的正常运行。
              我们不会访问、分析或共享这些数据。
            </p>
          </section>

          <section className="section">
            <h2>3. 信息存储</h2>
            <p>
              您的所有数据都存储在您的设备本地存储中。当您卸载应用时，这些数据将被完全删除。
              我们没有任何服务器存储您的个人信息或使用数据。
            </p>
          </section>

          <section className="section">
            <h2>4. 信息共享</h2>
            <p>
              我们不会与任何第三方共享、出售或出租您的个人信息。本应用不包含任何第三方追踪工具或广告服务。
            </p>
          </section>

          <section className="section">
            <h2>5. 数据安全</h2>
            <p>
              由于所有数据都存储在您的设备本地，数据安全性由您设备的安全措施保障。
              我们建议您：
            </p>
            <ul>
              <li>保持设备操作系统更新</li>
              <li>使用设备密码或生物识别锁定</li>
              <li>不要在未授权的设备上登录您的账户</li>
            </ul>
          </section>

          <section className="section">
            <h2>6. 儿童隐私保护</h2>
            <p>
              本应用适合所有年龄段的用户使用。我们不会主动收集任何用户的个人信息，包括儿童用户。
            </p>
          </section>

          <section className="section">
            <h2>7. 隐私政策的变更</h2>
            <p>
              我们可能会不定期更新本隐私政策。更新后的政策将在本页面发布，并更新"最后更新日期"。
              如有重大变更，我们会在应用内通知您。
            </p>
          </section>

          <section className="section">
            <h2>8. 联系我们</h2>
            <p>
              如果您对本隐私政策有任何疑问、意见或建议，欢迎通过以下方式联系我们：
            </p>
            <div className="contact-info">
              <p><strong>邮箱：</strong> wsmslgh@gmail.com</p>
              <p><strong>地址：</strong> 请通过邮箱联系我们获取详细地址</p>
            </div>
          </section>

          <section className="section">
            <h2>9. 您的权利</h2>
            <p>
              由于我们不收集或存储您的个人信息，您无需担心数据访问、更正或删除的问题。
              您可以随时通过卸载应用来清除所有本地数据。
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Privacy;
